export const filterSearchableItems = <T,>(
  items: T[],
  search: string,
  getSearchText: (item: T) => string
): T[] => {
  const normalizedSearch = search
    .trim()
    .toLowerCase();

  if (!normalizedSearch) {
    return items;
  }

  return items.filter((item) =>
    getSearchText(item)
      .toLowerCase()
      .includes(normalizedSearch)
  );
};